import { RefObject, useEffect, useRef } from 'react';
import type { Swiper } from 'swiper/types';

export const useSwiperFocus = (swiper: Swiper | undefined, containerRef: RefObject<HTMLElement>) => {
  const isTabPressed = useRef(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        isTabPressed.current = true;
      }
    };

    const handleMouseDown = () => {
      isTabPressed.current = false;
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  useEffect(() => {
    if (!swiper || !containerRef.current || swiper.destroyed) return;

    const handleFocusIn = (e: FocusEvent) => {
      if (!isTabPressed.current) return;

      const target = e.target as HTMLElement;
      if (!containerRef.current?.contains(target)) return;

      if (swiper.activeIndex !== 0) {
        swiper.slideTo(0);
      }
      isTabPressed.current = false;
    };

    const container = containerRef.current;
    container.addEventListener('focusin', handleFocusIn);

    return () => {
      container.removeEventListener('focusin', handleFocusIn);
    };
  }, [swiper, containerRef]);
};
